import Modal, {ModalProps} from './Modal';

function AboutModal(props: ModalProps) {
    const { onClose } = props;

    const personalSiteLink = 'https://theodubiel.com';

    const navigateToExternalLink = (link: string) => {
        window.open(link, '_blank');
    }

    return (
        <Modal onClose={onClose}>
            <div className="small">
                <div className="title">About</div>
                <div className="info">
                    I've always loved building worlds, so I decided to create this project to give people a small avenue for creativity. Edit the land, water and atmosphere. Place plants, rocks, and other features. Most importantly, have fun!
                </div>
                <div className="info">
                    Special thanks to <b>Liam Selfors</b> for the music!
                </div>
                <div className="info">
                    - Theo
                </div>
                <div className="button" onClick={() => navigateToExternalLink(personalSiteLink)}>Personal Site</div>
                <div className="button" onClick={onClose}>Close</div>
            </div>
        </Modal>
    );
}

export default AboutModal;
